// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3c%21--%20-%20SPDX-FileCopyrightText:%202020%20Google%20Inc.%20-%20SPDX-License-Identifier:%20Apache-2.0%20--%3e%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20width=%2724%27%20height=%2724%27%20fill=%27%23222%27%3e%3cpath%20d=%27M18.4%207.4L17%206l-6%206%206%206%201.4-1.4-4.6-4.6%204.6-4.6m-6%200L11%206l-6%206%206%206%201.4-1.4L7.8%2012l4.6-4.6z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3c%21--%20-%20SPDX-FileCopyrightText:%202020%20Google%20Inc.%20-%20SPDX-License-Identifier:%20Apache-2.0%20--%3e%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20width=%2724%27%20height=%2724%27%20fill=%27%23222%27%3e%3cpath%20d=%27M15.4%2016.6L10.8%2012l4.6-4.6L14%206l-6%206%206%206%201.4-1.4z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3c%21--%20-%20SPDX-FileCopyrightText:%202020%20Google%20Inc.%20-%20SPDX-License-Identifier:%20Apache-2.0%20--%3e%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20width=%2724%27%20height=%2724%27%20fill=%27%23222%27%3e%3cpath%20d=%27M8.6%2016.6l4.6-4.6-4.6-4.6L10%206l6%206-6%206-1.4-1.4z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3c%21--%20-%20SPDX-FileCopyrightText:%202020%20Google%20Inc.%20-%20SPDX-License-Identifier:%20Apache-2.0%20--%3e%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20width=%2724%27%20height=%2724%27%20fill=%27%23222%27%3e%3cpath%20d=%27M5.6%207.4L7%206l6%206-6%206-1.4-1.4%204.6-4.6-4.6-4.6m6%200L13%206l6%206-6%206-1.4-1.4%204.6-4.6-4.6-4.6z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
/**
* SPDX-FileCopyrightText: 2020 Nextcloud GmbH and Nextcloud contributors
* SPDX-License-Identifier: AGPL-3.0-or-later
*/
.mx-icon-left:before,
.mx-icon-right:before,
.mx-icon-double-left:before,
.mx-icon-double-right:before,
.mx-icon-double-left:after,
.mx-icon-double-right:after {
  content: "";
  position: relative;
  top: -1px;
  display: inline-block;
  width: 10px;
  height: 10px;
  vertical-align: middle;
  border-style: solid;
  border-color: currentColor;
  border-width: 2px 0 0 2px;
  border-radius: 1px;
  box-sizing: border-box;
  transform-origin: center;
  transform: rotate(-45deg) scale(0.7);
}
.mx-icon-double-left:after {
  left: -4px;
}
.mx-icon-double-right:before {
  left: 4px;
}
.mx-icon-right:before,
.mx-icon-double-right:before,
.mx-icon-double-right:after {
  transform: rotate(135deg) scale(0.7);
}
.mx-btn {
  box-sizing: border-box;
  line-height: 1;
  font-size: 14px;
  font-weight: 500;
  padding: 7px 15px;
  margin: 0;
  cursor: pointer;
  background-color: transparent;
  outline: none;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  color: #73879c;
  white-space: nowrap;
}
.mx-btn:hover {
  border-color: #1284e7;
  color: #1284e7;
}
.mx-btn:disabled, .mx-btn.disabled {
  color: #ccc;
  cursor: not-allowed;
}
.mx-btn-text {
  border: 0;
  padding: 0 4px;
  text-align: left;
  line-height: inherit;
}
.mx-scrollbar {
  height: 100%;
}
.mx-scrollbar:hover .mx-scrollbar-track {
  opacity: 1;
}
.mx-scrollbar-wrap {
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
}
.mx-scrollbar-track {
  position: absolute;
  top: 2px;
  right: 2px;
  bottom: 2px;
  width: 6px;
  z-index: 1;
  border-radius: 4px;
  opacity: 0;
  transition: opacity 0.24s ease-out;
}
.mx-scrollbar-track .mx-scrollbar-thumb {
  position: absolute;
  width: 100%;
  height: 0;
  cursor: pointer;
  border-radius: inherit;
  background-color: rgba(144, 147, 153, 0.3);
  transition: background-color 0.3s;
}
.mx-zoom-in-down-enter-active,
.mx-zoom-in-down-leave-active {
  opacity: 1;
  transform: scaleY(1);
  transition: transform 0.3s cubic-bezier(0.23, 1, 0.32, 1), opacity 0.3s cubic-bezier(0.23, 1, 0.32, 1);
  transform-origin: center top;
}
.mx-zoom-in-down-enter,
.mx-zoom-in-down-enter-from,
.mx-zoom-in-down-leave-to {
  opacity: 0;
  transform: scaleY(0);
}
.mx-datepicker {
  position: relative;
  display: inline-block;
  width: 210px;
}
.mx-datepicker svg {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
.mx-datepicker-range {
  width: 320px;
}
.mx-datepicker-inline {
  width: auto;
}
.mx-input-wrapper {
  position: relative;
}
.mx-input {
  display: inline-block;
  box-sizing: border-box;
  width: 100%;
  height: 34px;
  padding: 6px 30px;
  padding-left: 10px;
  font-size: 14px;
  line-height: 1.4;
  color: #555;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
}
.mx-input:hover, .mx-input:focus {
  border-color: #409aff;
}
.mx-input:disabled, .mx-input.disabled {
  color: #ccc;
  background-color: #f3f3f3;
  border-color: #ccc;
  cursor: not-allowed;
}
.mx-input:focus {
  outline: none;
}
.mx-input::-ms-clear {
  display: none;
}
.mx-icon-calendar,
.mx-icon-clear {
  position: absolute;
  top: 50%;
  right: 8px;
  transform: translateY(-50%);
  font-size: 16px;
  line-height: 1;
  color: rgba(0, 0, 0, 0.5);
  vertical-align: middle;
}
.mx-icon-clear {
  cursor: pointer;
}
.mx-icon-clear:hover {
  color: rgba(0, 0, 0, 0.8);
}
.mx-datepicker-main {
  font: 14px/1.5 "Helvetica Neue", Helvetica, Arial, "Microsoft Yahei", sans-serif;
  color: #73879c;
  background-color: #fff;
  border: 1px solid #e8e8e8;
}
.mx-datepicker-popup {
  position: absolute;
  margin-top: 1px;
  margin-bottom: 1px;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
  z-index: 2001;
}
.mx-datepicker-sidebar {
  float: left;
  box-sizing: border-box;
  width: 100px;
  padding: 6px;
  overflow: auto;
}
.mx-datepicker-sidebar + .mx-datepicker-content {
  margin-left: 100px;
  border-left: 1px solid #e8e8e8;
}
.mx-datepicker-body {
  position: relative;
  user-select: none;
}
.mx-btn-shortcut {
  display: block;
  padding: 0 6px;
  line-height: 24px;
}
.mx-range-wrapper {
  display: flex;
}
@media (max-width: 750px) {
  .mx-range-wrapper {
    flex-direction: column;
  }
}
.mx-datepicker-header {
  padding: 6px 8px;
  border-bottom: 1px solid #e8e8e8;
}
.mx-datepicker-footer {
  padding: 6px 8px;
  text-align: right;
  border-top: 1px solid #e8e8e8;
}
.mx-calendar {
  box-sizing: border-box;
  width: 248px;
  padding: 6px 12px;
}
.mx-calendar + .mx-calendar {
  border-left: 1px solid #e8e8e8;
}
.mx-calendar-header, .mx-time-header {
  box-sizing: border-box;
  height: 34px;
  line-height: 34px;
  text-align: center;
  overflow: hidden;
}
.mx-btn-icon-left,
.mx-btn-icon-double-left {
  float: left;
}
.mx-btn-icon-right,
.mx-btn-icon-double-right {
  float: right;
}
.mx-calendar-header-label {
  font-size: 14px;
}
.mx-calendar-decade-separator {
  margin: 0 2px;
}
.mx-calendar-decade-separator:after {
  content: "~";
}
.mx-calendar-content {
  position: relative;
  height: 224px;
  box-sizing: border-box;
}
.mx-calendar-content .cell {
  cursor: pointer;
}
.mx-calendar-content .cell:hover {
  color: #73879c;
  background-color: #f3f9fe;
}
.mx-calendar-content .cell.active {
  color: #fff;
  background-color: #1284e7;
}
.mx-calendar-content .cell.in-range, .mx-calendar-content .cell.hover-in-range {
  color: #73879c;
  background-color: #dbedfb;
}
.mx-calendar-content .cell.disabled {
  cursor: not-allowed;
  color: #ccc;
  background-color: #f3f3f3;
}
.mx-calendar-week-mode .mx-date-row {
  cursor: pointer;
}
.mx-calendar-week-mode .mx-date-row:hover {
  background-color: #f3f9fe;
}
.mx-calendar-week-mode .mx-date-row.mx-active-week {
  background-color: #dbedfb;
}
.mx-calendar-week-mode .mx-date-row .cell:hover {
  color: inherit;
  background-color: transparent;
}
.mx-calendar-week-mode .mx-date-row .cell.active {
  color: inherit;
  background-color: transparent;
}
.mx-week-number {
  opacity: 0.5;
}
.mx-table {
  table-layout: fixed;
  border-collapse: separate;
  border-spacing: 0;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  text-align: center;
}
.mx-table th {
  padding: 0;
  font-weight: 500;
  vertical-align: middle;
}
.mx-table td {
  padding: 0;
  vertical-align: middle;
}
.mx-table-date td,
.mx-table-date th {
  height: 32px;
  font-size: 12px;
}
.mx-table-date .today {
  color: #2a90e9;
}
.mx-table-date .cell.not-current-month {
  color: #ccc;
  background: none;
}
.mx-time {
  flex: 1;
  width: 224px;
  background: #fff;
}
.mx-time + .mx-time {
  border-left: 1px solid #e8e8e8;
}
.mx-calendar-time {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.mx-time-header {
  border-bottom: 1px solid #e8e8e8;
}
.mx-time-content {
  height: 224px;
  box-sizing: border-box;
  overflow: hidden;
}
.mx-time-columns {
  display: flex;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.mx-time-column {
  flex: 1;
  position: relative;
  border-left: 1px solid #e8e8e8;
  text-align: center;
}
.mx-time-column:first-child {
  border-left: 0;
}
.mx-time-column .mx-time-list {
  margin: 0;
  padding: 0;
  list-style: none;
}
.mx-time-column .mx-time-list::after {
  content: "";
  display: block;
  height: 192px;
}
.mx-time-column .mx-time-item {
  cursor: pointer;
  font-size: 12px;
  height: 32px;
  line-height: 32px;
}
.mx-time-column .mx-time-item:hover {
  color: #73879c;
  background-color: #f3f9fe;
}
.mx-time-column .mx-time-item.active {
  color: #1284e7;
  background-color: transparent;
  font-weight: 700;
}
.mx-time-column .mx-time-item.disabled {
  cursor: not-allowed;
  color: #ccc;
  background-color: #f3f3f3;
}
.mx-time-option {
  cursor: pointer;
  padding: 8px 10px;
  font-size: 14px;
  line-height: 20px;
}
.mx-time-option:hover {
  color: #73879c;
  background-color: #f3f9fe;
}
.mx-time-option.active {
  color: #1284e7;
  background-color: transparent;
  font-weight: 700;
}
.mx-time-option.disabled {
  cursor: not-allowed;
  color: #ccc;
  background-color: #f3f3f3;
}
.mx-datepicker[data-v-ac203b9] {
  user-select: none;
  color: var(--color-main-text);
  /* INPUT CONTAINER */
}
.mx-datepicker[data-v-ac203b9] svg {
  fill: var(--color-main-text);
}
.mx-datepicker[data-v-ac203b9] .mx-input-wrapper .mx-input {
  width: 100%;
  border: 2px solid var(--color-border-maxcontrast);
  background-color: var(--color-main-background);
  background-clip: content-box;
}
.mx-datepicker[data-v-ac203b9] .mx-input-wrapper .mx-input:active:not(.disabled), .mx-datepicker[data-v-ac203b9] .mx-input-wrapper .mx-input:hover:not(.disabled), .mx-datepicker[data-v-ac203b9] .mx-input-wrapper .mx-input:focus:not(.disabled) {
  border-color: var(--color-primary-element);
}
.mx-datepicker[data-v-ac203b9] .mx-input-wrapper:disabled, .mx-datepicker[data-v-ac203b9] .mx-input-wrapper.disabled {
  cursor: not-allowed;
  opacity: 0.7;
}
.mx-datepicker[data-v-ac203b9] .mx-input-wrapper .mx-icon-calendar,
.mx-datepicker[data-v-ac203b9] .mx-input-wrapper .mx-icon-clear {
  color: var(--color-text-lighter);
}
.mx-datepicker-main {
  color: var(--color-main-text);
  border: 1px solid var(--color-border);
  background-color: var(--color-main-background);
  font-family: var(--font-face) !important;
  line-height: 1.5;
}
.mx-datepicker-main svg {
  fill: var(--color-main-text);
}
.mx-datepicker-main.mx-datepicker-popup {
  z-index: 2000;
  box-shadow: none;
}
.mx-datepicker-main.mx-datepicker-popup .mx-datepicker-sidebar + .mx-datepicker-content {
  border-left: 1px solid var(--color-border);
}
.mx-datepicker-main.show-week-number .mx-calendar {
  width: 296px;
}
.mx-datepicker-main .mx-datepicker-header {
  border-bottom: 1px solid var(--color-border);
}
.mx-datepicker-main .mx-datepicker-footer {
  border-top: 1px solid var(--color-border);
}
.mx-datepicker-main .mx-datepicker-btn-confirm {
  background-color: var(--color-primary-element);
  border-color: var(--color-primary-element);
  color: var(--color-primary-element-text) !important;
  opacity: 1 !important;
}
.mx-datepicker-main .mx-datepicker-btn-confirm:hover {
  background-color: var(--color-primary-element-light) !important;
  border-color: var(--color-primary-element-light) !important;
}
.mx-datepicker-main .mx-calendar {
  width: 264px;
  padding: 5px;
}
.mx-datepicker-main .mx-calendar.mx-calendar-week-mode {
  width: 296px;
}
.mx-datepicker-main .mx-time + .mx-time,
.mx-datepicker-main .mx-calendar + .mx-calendar {
  border-left: 1px solid var(--color-border);
}
.mx-datepicker-main .mx-range-wrapper {
  display: flex;
  overflow: hidden;
}
.mx-datepicker-main .mx-range-wrapper .mx-calendar-content .mx-table-date .cell.active {
  border-radius: var(--border-radius) 0 0 var(--border-radius);
}
.mx-datepicker-main .mx-range-wrapper .mx-calendar-content .mx-table-date .cell.in-range + .cell.active {
  border-radius: 0 var(--border-radius) var(--border-radius) 0;
}
.mx-datepicker-main .mx-table {
  text-align: center;
}
.mx-datepicker-main .mx-table thead > tr > th {
  text-align: center;
  opacity: 0.5;
  color: var(--color-text-lighter);
}
.mx-datepicker-main .mx-table tr:focus,
.mx-datepicker-main .mx-table tr:hover,
.mx-datepicker-main .mx-table tr:active {
  background-color: transparent;
}
.mx-datepicker-main .mx-table .cell {
  transition: all 100ms ease-in-out;
  text-align: center;
  opacity: 0.7;
  border-radius: 50px;
}
.mx-datepicker-main .mx-table .cell > * {
  cursor: pointer;
}
.mx-datepicker-main .mx-table .cell.today {
  opacity: 1;
  color: var(--color-primary-element);
  font-weight: bold;
}
.mx-datepicker-main .mx-table .cell.today:hover, .mx-datepicker-main .mx-table .cell.today:focus {
  color: var(--color-primary-element-text);
}
.mx-datepicker-main .mx-table .cell.in-range, .mx-datepicker-main .mx-table .cell.disabled {
  border-radius: 0;
  font-weight: normal;
}
.mx-datepicker-main .mx-table .cell.in-range {
  opacity: 0.7;
}
.mx-datepicker-main .mx-table .cell.not-current-month {
  opacity: 0.5;
  color: var(--color-text-lighter);
}
.mx-datepicker-main .mx-table .cell.not-current-month:hover, .mx-datepicker-main .mx-table .cell.not-current-month:focus {
  opacity: 1;
}
.mx-datepicker-main .mx-table .cell:hover, .mx-datepicker-main .mx-table .cell:focus, .mx-datepicker-main .mx-table .cell.actived, .mx-datepicker-main .mx-table .cell.active, .mx-datepicker-main .mx-table .cell.in-range {
  opacity: 1;
  color: var(--color-primary-element-text);
  background-color: var(--color-primary-element);
  font-weight: bold;
}
.mx-datepicker-main .mx-table .cell.disabled {
  opacity: 0.5;
  color: var(--color-text-lighter);
  border-radius: 0;
  background-color: var(--color-background-darker);
}
.mx-datepicker-main .mx-table .mx-week-number {
  text-align: center;
  opacity: 0.7;
  border-radius: 50px;
}
.mx-datepicker-main .mx-table span.mx-week-number,
.mx-datepicker-main .mx-table li.mx-week-number,
.mx-datepicker-main .mx-table span.cell,
.mx-datepicker-main .mx-table li.cell {
  min-height: 32px;
}
.mx-datepicker-main .mx-table.mx-table-date thead, .mx-datepicker-main .mx-table.mx-table-date tbody, .mx-datepicker-main .mx-table.mx-table-year, .mx-datepicker-main .mx-table.mx-table-month {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
.mx-datepicker-main .mx-table.mx-table-date thead tr, .mx-datepicker-main .mx-table.mx-table-date tbody tr, .mx-datepicker-main .mx-table.mx-table-year tr, .mx-datepicker-main .mx-table.mx-table-month tr {
  display: inline-flex;
  align-items: center;
  flex: 1 1 32px;
  justify-content: space-around;
  min-height: 32px;
}
.mx-datepicker-main .mx-table.mx-table-date thead th,
.mx-datepicker-main .mx-table.mx-table-date thead td, .mx-datepicker-main .mx-table.mx-table-date tbody th,
.mx-datepicker-main .mx-table.mx-table-date tbody td, .mx-datepicker-main .mx-table.mx-table-year th,
.mx-datepicker-main .mx-table.mx-table-year td, .mx-datepicker-main .mx-table.mx-table-month th,
.mx-datepicker-main .mx-table.mx-table-month td {
  display: flex;
  align-items: center;
  flex: 0 1 32%;
  justify-content: center;
  min-width: 32px;
  height: 95%;
  min-height: 32px;
  transition: background 100ms ease-in-out;
}
.mx-datepicker-main .mx-table.mx-table-year tr th,
.mx-datepicker-main .mx-table.mx-table-year tr td {
  flex-basis: 48%;
}
.mx-datepicker-main .mx-table.mx-table-date tr th,
.mx-datepicker-main .mx-table.mx-table-date tr td {
  flex-basis: 32px;
}
.mx-datepicker-main .mx-btn {
  min-width: 32px;
  height: 32px;
  margin: 0 2px !important;
  padding: 7px 10px;
  cursor: pointer;
  text-decoration: none;
  opacity: 0.5;
  color: var(--color-text-lighter);
  border-radius: 32px;
  line-height: 20px;
}
.mx-datepicker-main .mx-btn:hover, .mx-datepicker-main .mx-btn:focus {
  opacity: 1;
  color: var(--color-main-text);
  background-color: var(--color-background-darker);
}
.mx-datepicker-main .mx-calendar-header, .mx-datepicker-main .mx-time-header {
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: var(--default-clickable-area);
  margin-bottom: 4px;
}
.mx-datepicker-main .mx-calendar-header button, .mx-datepicker-main .mx-time-header button {
  min-width: 32px;
  min-height: 32px;
  margin: 0;
  cursor: pointer;
  text-align: center;
  text-decoration: none;
  opacity: 0.7;
  color: var(--color-main-text);
  border-radius: 32px;
  line-height: 20px;
}
.mx-datepicker-main .mx-calendar-header button:hover, .mx-datepicker-main .mx-time-header button:hover, .mx-datepicker-main .mx-calendar-header button:focus, .mx-datepicker-main .mx-time-header button:focus {
  opacity: 1;
  color: var(--color-main-text);
  background-color: var(--color-background-darker);
}
.mx-datepicker-main .mx-calendar-header button.mx-btn-icon-double-left, .mx-datepicker-main .mx-time-header button.mx-btn-icon-double-left, .mx-datepicker-main .mx-calendar-header button.mx-btn-icon-left, .mx-datepicker-main .mx-time-header button.mx-btn-icon-left, .mx-datepicker-main .mx-calendar-header button.mx-btn-icon-right, .mx-datepicker-main .mx-time-header button.mx-btn-icon-right, .mx-datepicker-main .mx-calendar-header button.mx-btn-icon-double-right, .mx-datepicker-main .mx-time-header button.mx-btn-icon-double-right {
  align-items: center;
  justify-content: center;
  width: 32px;
  padding: 0;
}
.mx-datepicker-main .mx-calendar-header button.mx-btn-icon-double-left > i, .mx-datepicker-main .mx-time-header button.mx-btn-icon-double-left > i, .mx-datepicker-main .mx-calendar-header button.mx-btn-icon-left > i, .mx-datepicker-main .mx-time-header button.mx-btn-icon-left > i, .mx-datepicker-main .mx-calendar-header button.mx-btn-icon-right > i, .mx-datepicker-main .mx-time-header button.mx-btn-icon-right > i, .mx-datepicker-main .mx-calendar-header button.mx-btn-icon-double-right > i, .mx-datepicker-main .mx-time-header button.mx-btn-icon-double-right > i {
  background-repeat: no-repeat;
  background-size: 16px;
  background-position: center;
  filter: var(--background-invert-if-dark);
  display: inline-block;
  width: 32px;
  height: 32px;
}
.mx-datepicker-main .mx-calendar-header button.mx-btn-icon-double-left > i::after, .mx-datepicker-main .mx-time-header button.mx-btn-icon-double-left > i::after, .mx-datepicker-main .mx-calendar-header button.mx-btn-icon-double-left > i::before, .mx-datepicker-main .mx-time-header button.mx-btn-icon-double-left > i::before, .mx-datepicker-main .mx-calendar-header button.mx-btn-icon-left > i::after, .mx-datepicker-main .mx-time-header button.mx-btn-icon-left > i::after, .mx-datepicker-main .mx-calendar-header button.mx-btn-icon-left > i::before, .mx-datepicker-main .mx-time-header button.mx-btn-icon-left > i::before, .mx-datepicker-main .mx-calendar-header button.mx-btn-icon-right > i::after, .mx-datepicker-main .mx-time-header button.mx-btn-icon-right > i::after, .mx-datepicker-main .mx-calendar-header button.mx-btn-icon-right > i::before, .mx-datepicker-main .mx-time-header button.mx-btn-icon-right > i::before, .mx-datepicker-main .mx-calendar-header button.mx-btn-icon-double-right > i::after, .mx-datepicker-main .mx-time-header button.mx-btn-icon-double-right > i::after, .mx-datepicker-main .mx-calendar-header button.mx-btn-icon-double-right > i::before, .mx-datepicker-main .mx-time-header button.mx-btn-icon-double-right > i::before {
  content: none;
}
.mx-datepicker-main .mx-calendar-header button.mx-btn-text, .mx-datepicker-main .mx-time-header button.mx-btn-text {
  line-height: initial;
}
.mx-datepicker-main .mx-calendar-header .mx-calendar-header-label, .mx-datepicker-main .mx-time-header .mx-calendar-header-label {
  display: flex;
}
.mx-datepicker-main .mx-calendar-header .mx-btn-icon-double-left > i, .mx-datepicker-main .mx-time-header .mx-btn-icon-double-left > i {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.mx-datepicker-main .mx-calendar-header .mx-btn-icon-left > i, .mx-datepicker-main .mx-time-header .mx-btn-icon-left > i {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
.mx-datepicker-main .mx-calendar-header .mx-btn-icon-right > i, .mx-datepicker-main .mx-time-header .mx-btn-icon-right > i {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
.mx-datepicker-main .mx-calendar-header .mx-btn-icon-double-right > i, .mx-datepicker-main .mx-time-header .mx-btn-icon-double-right > i {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
.mx-datepicker-main .mx-calendar-header button.mx-btn-icon-right, .mx-datepicker-main .mx-time-header button.mx-btn-icon-right {
  order: 2;
}
.mx-datepicker-main .mx-calendar-header button.mx-btn-icon-double-right, .mx-datepicker-main .mx-time-header button.mx-btn-icon-double-right {
  order: 3;
}
.mx-datepicker-main .mx-calendar-week-mode .mx-date-row .mx-week-number {
  font-weight: bold;
}
.mx-datepicker-main .mx-calendar-week-mode .mx-date-row:hover, .mx-datepicker-main .mx-calendar-week-mode .mx-date-row.mx-active-week {
  opacity: 1;
  border-radius: 50px;
  background-color: var(--color-background-dark);
}
.mx-datepicker-main .mx-calendar-week-mode .mx-date-row:hover td, .mx-datepicker-main .mx-calendar-week-mode .mx-date-row.mx-active-week td {
  background-color: transparent;
}
.mx-datepicker-main .mx-calendar-week-mode .mx-date-row:hover td, .mx-datepicker-main .mx-calendar-week-mode .mx-date-row:hover td:hover, .mx-datepicker-main .mx-calendar-week-mode .mx-date-row:hover td:focus, .mx-datepicker-main .mx-calendar-week-mode .mx-date-row.mx-active-week td, .mx-datepicker-main .mx-calendar-week-mode .mx-date-row.mx-active-week td:hover, .mx-datepicker-main .mx-calendar-week-mode .mx-date-row.mx-active-week td:focus {
  color: inherit;
}
.mx-datepicker-main .mx-calendar-week-mode .mx-date-row.mx-active-week {
  color: var(--color-primary-element-text);
  background-color: var(--color-primary-element);
}
.mx-datepicker-main .mx-calendar-week-mode .mx-date-row.mx-active-week td {
  opacity: 0.7;
  font-weight: normal;
}
.mx-datepicker-main .mx-time {
  background-color: var(--color-main-background);
}
.mx-datepicker-main .mx-time .mx-time-header {
  justify-content: center;
  border-bottom: 1px solid var(--color-border);
}
.mx-datepicker-main .mx-time .mx-time-column {
  border-left: 1px solid var(--color-border);
}
.mx-datepicker-main .mx-time .mx-time-option.active, .mx-datepicker-main .mx-time .mx-time-option:hover,
.mx-datepicker-main .mx-time .mx-time-item.active,
.mx-datepicker-main .mx-time .mx-time-item:hover {
  color: var(--color-primary-element-text);
  background-color: var(--color-primary-element);
}
.mx-datepicker-main .mx-time .mx-time-option.disabled,
.mx-datepicker-main .mx-time .mx-time-item.disabled {
  cursor: not-allowed;
  opacity: 0.5;
  color: var(--color-main-text);
  background-color: var(--color-main-background);
}/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-4727c294] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.mx-datepicker[data-v-4727c294] .mx-input-wrapper .mx-input {
  background-clip: border-box;
}
.datetime-picker-inline-icon[data-v-4727c294] {
  opacity: 0.3;
  border: none;
  background-color: transparent;
  border-radius: 0;
  padding: 0 !important;
  margin: 0;
}
.datetime-picker-inline-icon--highlighted[data-v-4727c294] {
  opacity: 0.7;
}
.datetime-picker-inline-icon[data-v-4727c294]:focus, .datetime-picker-inline-icon[data-v-4727c294]:hover {
  opacity: 1;
}/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.v-popper--theme-dropdown.v-popper__popper.timezone-select__popper .v-popper__wrapper {
  border-radius: var(--border-radius-large);
}
.v-popper--theme-dropdown.v-popper__popper.timezone-select__popper .v-popper__wrapper .v-popper__inner {
  padding: 4px;
  border-radius: var(--border-radius-large);
}
.v-popper--theme-dropdown.v-popper__popper.timezone-select__popper .v-popper__wrapper .v-popper__inner .timezone-popover-wrapper__label {
  padding: 4px 0;
  padding-left: 14px;
}
.v-popper--theme-dropdown.v-popper__popper.timezone-select__popper .v-popper__wrapper .v-popper__inner .timezone-popover-wrapper__timezone-select.v-select .vs__dropdown-toggle {
  border-radius: calc(var(--border-radius-large) - 4px);
}
.v-popper--theme-dropdown.v-popper__popper.timezone-select__popper .v-popper__wrapper .v-popper__inner .timezone-popover-wrapper__timezone-select.v-select.vs--open .vs__dropdown-toggle {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
.v-popper--theme-dropdown.v-popper__popper.timezone-select__popper .v-popper__wrapper .v-popper__inner .timezone-popover-wrapper__timezone-select.v-select.vs--open.select--drop-up .vs__dropdown-toggle {
  border-radius: 0 0 calc(var(--border-radius-large) - 4px) calc(var(--border-radius-large) - 4px);
}
.vs__dropdown-menu--floating {
  z-index: 100001 !important;
}`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcDateTimePicker-BshzbbKT.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;;;CAGC;AACD;;;;;;EAME,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,0BAA0B;EAC1B,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,wBAAwB;EACxB,oCAAoC;AACtC;AACA;EACE,UAAU;AACZ;AACA;EACE,SAAS;AACX;AACA;;;EAGE,oCAAoC;AACtC;AACA;EACE,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;EACT,eAAe;EACf,6BAA6B;EAC7B,aAAa;EACb,oCAAoC;EACpC,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,cAAc;EACd,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,YAAY;AACd;AACA;EACE,UAAU;AACZ;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,UAAU;EACV,UAAU;EACV,kBAAkB;EAClB,UAAU;EACV,kCAAkC;AACpC;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,eAAe;EACf,sBAAsB;EACtB,0CAA0C;EAC1C,iCAAiC;AACnC;AACA;;EAEE,UAAU;EACV,oBAAoB;EACpB,sGAAsG;EACtG,4BAA4B;AAC9B;AACA;;;EAGE,UAAU;EACV,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;AACd;AACA;EACE,UAAU;EACV,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,gDAAgD;AAClD;AACA;EACE,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,2BAA2B;EAC3B,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,gFAAgF;EAChF,cAAc;EACd,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,2CAA2C;EAC3C,aAAa;AACf;AACA;EACE,WAAW;EACX,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,8BAA8B;AAChC;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;AACA;EACE;IACE,sBAAsB;EACxB;AACF;AACA;EACE,gBAAgB;EAChB,gCAAgC;AAClC;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;AACA;EACE,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;;EAEE,WAAW;AACb;AACA;;EAEE,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,6BAA6B;AAC/B;AACA;EACE,cAAc;EACd,6BAA6B;AAC/B;AACA;EACE,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,UAAU;EACV,sBAAsB;AACxB;AACA;;EAEE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,OAAO;EACP,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;AACd;AACA;EACE,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,OAAO;EACP,kBAAkB;EAClB,8BAA8B;EAC9B,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,cAAc;EACd,aAAa;AACf;AACA;EACE,eAAe;EACf,eAAe;EACf,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,oBAAoB;AACtB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,WAAW;EACX,iDAAiD;EACjD,8CAA8C;EAC9C,4BAA4B;AAC9B;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,mBAAmB;EACnB,YAAY;AACd;AACA;;EAEE,gCAAgC;AAClC;AACA;EACE,6BAA6B;EAC7B,qCAAqC;EACrC,8CAA8C;EAC9C,wCAAwC;EACxC,gBAAgB;AAClB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,YAAY;AACd;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,8CAA8C;EAC9C,0CAA0C;EAC1C,mDAAmD;EACnD,qBAAqB;AACvB;AACA;EACE,+DAA+D;EAC/D,2DAA2D;AAC7D;AACA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;;EAEE,0CAA0C;AAC5C;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,4DAA4D;AAC9D;AACA;EACE,4DAA4D;AAC9D;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,gCAAgC;AAClC;AACA;;;EAGE,6BAA6B;AAC/B;AACA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,UAAU;EACV,mCAAmC;EACnC,iBAAiB;AACnB;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,gCAAgC;AAClC;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;EACV,wCAAwC;EACxC,8CAA8C;EAC9C,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,gCAAgC;EAChC,gBAAgB;EAChB,gDAAgD;AAClD;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;AACrB;AACA;;;;EAIE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;AAC/B;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;;;;;EAKE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,wCAAwC;AAC1C;AACA;;EAEE,eAAe;AACjB;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,YAAY;EACZ,wBAAwB;EACxB,iBAAiB;EACjB,eAAe;EACf,qBAAqB;EACrB,YAAY;EACZ,gCAAgC;EAChC,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,6BAA6B;EAC7B,gDAAgD;AAClD;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,qCAAqC;EACrC,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;EACZ,6BAA6B;EAC7B,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,6BAA6B;EAC7B,gDAAgD;AAClD;AACA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,UAAU;AACZ;AACA;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,2BAA2B;EAC3B,wCAAwC;EACxC,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,oBAAoB;AACtB;AACA;EACE,aAAa;AACf;AACA;EACE,yDAAsY;AACxY;AACA;EACE,yDAA+U;AACjV;AACA;EACE,yDAAuU;AACzU;AACA;EACE,yDAA0X;AAC5X;AACA;EACE,QAAQ;AACV;AACA;EACE,QAAQ;AACV;AACA;EACE,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,mBAAmB;EACnB,8CAA8C;AAChD;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,cAAc;AAChB;AACA;EACE,wCAAwC;EACxC,8CAA8C;AAChD;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,8CAA8C;AAChD;AACA;EACE,uBAAuB;EACvB,4CAA4C;AAC9C;AACA;EACE,0CAA0C;AAC5C;AACA;;;EAGE,wCAAwC;EACxC,8CAA8C;AAChD;AACA;;EAEE,mBAAmB;EACnB,YAAY;EACZ,6BAA6B;EAC7B,8CAA8C;AAChD,CAAC;;;EAGC;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,YAAY;EACZ,YAAY;EACZ,6BAA6B;EAC7B,gBAAgB;EAChB,qBAAqB;EACrB,SAAS;AACX;AACA;EACE,YAAY;AACd;AACA;EACE,UAAU;AACZ,CAAC;;;EAGC;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,YAAY;EACZ,yCAAyC;AAC3C;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,qDAAqD;AACvD;AACA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;EACE,gGAAgG;AAClG;AACA;EACE,0BAA0B;AAC5B","sourcesContent":["/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n/**\n* SPDX-FileCopyrightText: 2020 Nextcloud GmbH and Nextcloud contributors\n* SPDX-License-Identifier: AGPL-3.0-or-later\n*/\n.mx-icon-left:before,\n.mx-icon-right:before,\n.mx-icon-double-left:before,\n.mx-icon-double-right:before,\n.mx-icon-double-left:after,\n.mx-icon-double-right:after {\n  content: \"\";\n  position: relative;\n  top: -1px;\n  display: inline-block;\n  width: 10px;\n  height: 10px;\n  vertical-align: middle;\n  border-style: solid;\n  border-color: currentColor;\n  border-width: 2px 0 0 2px;\n  border-radius: 1px;\n  box-sizing: border-box;\n  transform-origin: center;\n  transform: rotate(-45deg) scale(0.7);\n}\n.mx-icon-double-left:after {\n  left: -4px;\n}\n.mx-icon-double-right:before {\n  left: 4px;\n}\n.mx-icon-right:before,\n.mx-icon-double-right:before,\n.mx-icon-double-right:after {\n  transform: rotate(135deg) scale(0.7);\n}\n.mx-btn {\n  box-sizing: border-box;\n  line-height: 1;\n  font-size: 14px;\n  font-weight: 500;\n  padding: 7px 15px;\n  margin: 0;\n  cursor: pointer;\n  background-color: transparent;\n  outline: none;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  border-radius: 4px;\n  color: #73879c;\n  white-space: nowrap;\n}\n.mx-btn:hover {\n  border-color: #1284e7;\n  color: #1284e7;\n}\n.mx-btn:disabled, .mx-btn.disabled {\n  color: #ccc;\n  cursor: not-allowed;\n}\n.mx-btn-text {\n  border: 0;\n  padding: 0 4px;\n  text-align: left;\n  line-height: inherit;\n}\n.mx-scrollbar {\n  height: 100%;\n}\n.mx-scrollbar:hover .mx-scrollbar-track {\n  opacity: 1;\n}\n.mx-scrollbar-wrap {\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n.mx-scrollbar-track {\n  position: absolute;\n  top: 2px;\n  right: 2px;\n  bottom: 2px;\n  width: 6px;\n  z-index: 1;\n  border-radius: 4px;\n  opacity: 0;\n  transition: opacity 0.24s ease-out;\n}\n.mx-scrollbar-track .mx-scrollbar-thumb {\n  position: absolute;\n  width: 100%;\n  height: 0;\n  cursor: pointer;\n  border-radius: inherit;\n  background-color: rgba(144, 147, 153, 0.3);\n  transition: background-color 0.3s;\n}\n.mx-zoom-in-down-enter-active,\n.mx-zoom-in-down-leave-active {\n  opacity: 1;\n  transform: scaleY(1);\n  transition: transform 0.3s cubic-bezier(0.23, 1, 0.32, 1), opacity 0.3s cubic-bezier(0.23, 1, 0.32, 1);\n  transform-origin: center top;\n}\n.mx-zoom-in-down-enter,\n.mx-zoom-in-down-enter-from,\n.mx-zoom-in-down-leave-to {\n  opacity: 0;\n  transform: scaleY(0);\n}\n.mx-datepicker {\n  position: relative;\n  display: inline-block;\n  width: 210px;\n}\n.mx-datepicker svg {\n  width: 1em;\n  height: 1em;\n  vertical-align: -0.15em;\n  fill: currentColor;\n  overflow: hidden;\n}\n.mx-datepicker-range {\n  width: 320px;\n}\n.mx-datepicker-inline {\n  width: auto;\n}\n.mx-input-wrapper {\n  position: relative;\n}\n.mx-input {\n  display: inline-block;\n  box-sizing: border-box;\n  width: 100%;\n  height: 34px;\n  padding: 6px 30px;\n  padding-left: 10px;\n  font-size: 14px;\n  line-height: 1.4;\n  color: #555;\n  background-color: #fff;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n}\n.mx-input:hover, .mx-input:focus {\n  border-color: #409aff;\n}\n.mx-input:disabled, .mx-input.disabled {\n  color: #ccc;\n  background-color: #f3f3f3;\n  border-color: #ccc;\n  cursor: not-allowed;\n}\n.mx-input:focus {\n  outline: none;\n}\n.mx-input::-ms-clear {\n  display: none;\n}\n.mx-icon-calendar,\n.mx-icon-clear {\n  position: absolute;\n  top: 50%;\n  right: 8px;\n  transform: translateY(-50%);\n  font-size: 16px;\n  line-height: 1;\n  color: rgba(0, 0, 0, 0.5);\n  vertical-align: middle;\n}\n.mx-icon-clear {\n  cursor: pointer;\n}\n.mx-icon-clear:hover {\n  color: rgba(0, 0, 0, 0.8);\n}\n.mx-datepicker-main {\n  font: 14px/1.5 \"Helvetica Neue\", Helvetica, Arial, \"Microsoft Yahei\", sans-serif;\n  color: #73879c;\n  background-color: #fff;\n  border: 1px solid #e8e8e8;\n}\n.mx-datepicker-popup {\n  position: absolute;\n  margin-top: 1px;\n  margin-bottom: 1px;\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);\n  z-index: 2001;\n}\n.mx-datepicker-sidebar {\n  float: left;\n  box-sizing: border-box;\n  width: 100px;\n  padding: 6px;\n  overflow: auto;\n}\n.mx-datepicker-sidebar + .mx-datepicker-content {\n  margin-left: 100px;\n  border-left: 1px solid #e8e8e8;\n}\n.mx-datepicker-body {\n  position: relative;\n  user-select: none;\n}\n.mx-btn-shortcut {\n  display: block;\n  padding: 0 6px;\n  line-height: 24px;\n}\n.mx-range-wrapper {\n  display: flex;\n}\n@media (max-width: 750px) {\n  .mx-range-wrapper {\n    flex-direction: column;\n  }\n}\n.mx-datepicker-header {\n  padding: 6px 8px;\n  border-bottom: 1px solid #e8e8e8;\n}\n.mx-datepicker-footer {\n  padding: 6px 8px;\n  text-align: right;\n  border-top: 1px solid #e8e8e8;\n}\n.mx-calendar {\n  box-sizing: border-box;\n  width: 248px;\n  padding: 6px 12px;\n}\n.mx-calendar + .mx-calendar {\n  border-left: 1px solid #e8e8e8;\n}\n.mx-calendar-header, .mx-time-header {\n  box-sizing: border-box;\n  height: 34px;\n  line-height: 34px;\n  text-align: center;\n  overflow: hidden;\n}\n.mx-btn-icon-left,\n.mx-btn-icon-double-left {\n  float: left;\n}\n.mx-btn-icon-right,\n.mx-btn-icon-double-right {\n  float: right;\n}\n.mx-calendar-header-label {\n  font-size: 14px;\n}\n.mx-calendar-decade-separator {\n  margin: 0 2px;\n}\n.mx-calendar-decade-separator:after {\n  content: \"~\";\n}\n.mx-calendar-content {\n  position: relative;\n  height: 224px;\n  box-sizing: border-box;\n}\n.mx-calendar-content .cell {\n  cursor: pointer;\n}\n.mx-calendar-content .cell:hover {\n  color: #73879c;\n  background-color: #f3f9fe;\n}\n.mx-calendar-content .cell.active {\n  color: #fff;\n  background-color: #1284e7;\n}\n.mx-calendar-content .cell.in-range, .mx-calendar-content .cell.hover-in-range {\n  color: #73879c;\n  background-color: #dbedfb;\n}\n.mx-calendar-content .cell.disabled {\n  cursor: not-allowed;\n  color: #ccc;\n  background-color: #f3f3f3;\n}\n.mx-calendar-week-mode .mx-date-row {\n  cursor: pointer;\n}\n.mx-calendar-week-mode .mx-date-row:hover {\n  background-color: #f3f9fe;\n}\n.mx-calendar-week-mode .mx-date-row.mx-active-week {\n  background-color: #dbedfb;\n}\n.mx-calendar-week-mode .mx-date-row .cell:hover {\n  color: inherit;\n  background-color: transparent;\n}\n.mx-calendar-week-mode .mx-date-row .cell.active {\n  color: inherit;\n  background-color: transparent;\n}\n.mx-week-number {\n  opacity: 0.5;\n}\n.mx-table {\n  table-layout: fixed;\n  border-collapse: separate;\n  border-spacing: 0;\n  width: 100%;\n  height: 100%;\n  box-sizing: border-box;\n  text-align: center;\n}\n.mx-table th {\n  padding: 0;\n  font-weight: 500;\n  vertical-align: middle;\n}\n.mx-table td {\n  padding: 0;\n  vertical-align: middle;\n}\n.mx-table-date td,\n.mx-table-date th {\n  height: 32px;\n  font-size: 12px;\n}\n.mx-table-date .today {\n  color: #2a90e9;\n}\n.mx-table-date .cell.not-current-month {\n  color: #ccc;\n  background: none;\n}\n.mx-time {\n  flex: 1;\n  width: 224px;\n  background: #fff;\n}\n.mx-time + .mx-time {\n  border-left: 1px solid #e8e8e8;\n}\n.mx-calendar-time {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n.mx-time-header {\n  border-bottom: 1px solid #e8e8e8;\n}\n.mx-time-content {\n  height: 224px;\n  box-sizing: border-box;\n  overflow: hidden;\n}\n.mx-time-columns {\n  display: flex;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n}\n.mx-time-column {\n  flex: 1;\n  position: relative;\n  border-left: 1px solid #e8e8e8;\n  text-align: center;\n}\n.mx-time-column:first-child {\n  border-left: 0;\n}\n.mx-time-column .mx-time-list {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n.mx-time-column .mx-time-list::after {\n  content: \"\";\n  display: block;\n  height: 192px;\n}\n.mx-time-column .mx-time-item {\n  cursor: pointer;\n  font-size: 12px;\n  height: 32px;\n  line-height: 32px;\n}\n.mx-time-column .mx-time-item:hover {\n  color: #73879c;\n  background-color: #f3f9fe;\n}\n.mx-time-column .mx-time-item.active {\n  color: #1284e7;\n  background-color: transparent;\n  font-weight: 700;\n}\n.mx-time-column .mx-time-item.disabled {\n  cursor: not-allowed;\n  color: #ccc;\n  background-color: #f3f3f3;\n}\n.mx-time-option {\n  cursor: pointer;\n  padding: 8px 10px;\n  font-size: 14px;\n  line-height: 20px;\n}\n.mx-time-option:hover {\n  color: #73879c;\n  background-color: #f3f9fe;\n}\n.mx-time-option.active {\n  color: #1284e7;\n  background-color: transparent;\n  font-weight: 700;\n}\n.mx-time-option.disabled {\n  cursor: not-allowed;\n  color: #ccc;\n  background-color: #f3f3f3;\n}\n.mx-datepicker[data-v-ac203b9] {\n  user-select: none;\n  color: var(--color-main-text);\n  /* INPUT CONTAINER */\n}\n.mx-datepicker[data-v-ac203b9] svg {\n  fill: var(--color-main-text);\n}\n.mx-datepicker[data-v-ac203b9] .mx-input-wrapper .mx-input {\n  width: 100%;\n  border: 2px solid var(--color-border-maxcontrast);\n  background-color: var(--color-main-background);\n  background-clip: content-box;\n}\n.mx-datepicker[data-v-ac203b9] .mx-input-wrapper .mx-input:active:not(.disabled), .mx-datepicker[data-v-ac203b9] .mx-input-wrapper .mx-input:hover:not(.disabled), .mx-datepicker[data-v-ac203b9] .mx-input-wrapper .mx-input:focus:not(.disabled) {\n  border-color: var(--color-primary-element);\n}\n.mx-datepicker[data-v-ac203b9] .mx-input-wrapper:disabled, .mx-datepicker[data-v-ac203b9] .mx-input-wrapper.disabled {\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n.mx-datepicker[data-v-ac203b9] .mx-input-wrapper .mx-icon-calendar,\n.mx-datepicker[data-v-ac203b9] .mx-input-wrapper .mx-icon-clear {\n  color: var(--color-text-lighter);\n}\n.mx-datepicker-main {\n  color: var(--color-main-text);\n  border: 1px solid var(--color-border);\n  background-color: var(--color-main-background);\n  font-family: var(--font-face) !important;\n  line-height: 1.5;\n}\n.mx-datepicker-main svg {\n  fill: var(--color-main-text);\n}\n.mx-datepicker-main.mx-datepicker-popup {\n  z-index: 2000;\n  box-shadow: none;\n}\n.mx-datepicker-main.mx-datepicker-popup .mx-datepicker-sidebar + .mx-datepicker-content {\n  border-left: 1px solid var(--color-border);\n}\n.mx-datepicker-main.show-week-number .mx-calendar {\n  width: 296px;\n}\n.mx-datepicker-main .mx-datepicker-header {\n  border-bottom: 1px solid var(--color-border);\n}\n.mx-datepicker-main .mx-datepicker-footer {\n  border-top: 1px solid var(--color-border);\n}\n.mx-datepicker-main .mx-datepicker-btn-confirm {\n  background-color: var(--color-primary-element);\n  border-color: var(--color-primary-element);\n  color: var(--color-primary-element-text) !important;\n  opacity: 1 !important;\n}\n.mx-datepicker-main .mx-datepicker-btn-confirm:hover {\n  background-color: var(--color-primary-element-light) !important;\n  border-color: var(--color-primary-element-light) !important;\n}\n.mx-datepicker-main .mx-calendar {\n  width: 264px;\n  padding: 5px;\n}\n.mx-datepicker-main .mx-calendar.mx-calendar-week-mode {\n  width: 296px;\n}\n.mx-datepicker-main .mx-time + .mx-time,\n.mx-datepicker-main .mx-calendar + .mx-calendar {\n  border-left: 1px solid var(--color-border);\n}\n.mx-datepicker-main .mx-range-wrapper {\n  display: flex;\n  overflow: hidden;\n}\n.mx-datepicker-main .mx-range-wrapper .mx-calendar-content .mx-table-date .cell.active {\n  border-radius: var(--border-radius) 0 0 var(--border-radius);\n}\n.mx-datepicker-main .mx-range-wrapper .mx-calendar-content .mx-table-date .cell.in-range + .cell.active {\n  border-radius: 0 var(--border-radius) var(--border-radius) 0;\n}\n.mx-datepicker-main .mx-table {\n  text-align: center;\n}\n.mx-datepicker-main .mx-table thead > tr > th {\n  text-align: center;\n  opacity: 0.5;\n  color: var(--color-text-lighter);\n}\n.mx-datepicker-main .mx-table tr:focus,\n.mx-datepicker-main .mx-table tr:hover,\n.mx-datepicker-main .mx-table tr:active {\n  background-color: transparent;\n}\n.mx-datepicker-main .mx-table .cell {\n  transition: all 100ms ease-in-out;\n  text-align: center;\n  opacity: 0.7;\n  border-radius: 50px;\n}\n.mx-datepicker-main .mx-table .cell > * {\n  cursor: pointer;\n}\n.mx-datepicker-main .mx-table .cell.today {\n  opacity: 1;\n  color: var(--color-primary-element);\n  font-weight: bold;\n}\n.mx-datepicker-main .mx-table .cell.today:hover, .mx-datepicker-main .mx-table .cell.today:focus {\n  color: var(--color-primary-element-text);\n}\n.mx-datepicker-main .mx-table .cell.in-range, .mx-datepicker-main .mx-table .cell.disabled {\n  border-radius: 0;\n  font-weight: normal;\n}\n.mx-datepicker-main .mx-table .cell.in-range {\n  opacity: 0.7;\n}\n.mx-datepicker-main .mx-table .cell.not-current-month {\n  opacity: 0.5;\n  color: var(--color-text-lighter);\n}\n.mx-datepicker-main .mx-table .cell.not-current-month:hover, .mx-datepicker-main .mx-table .cell.not-current-month:focus {\n  opacity: 1;\n}\n.mx-datepicker-main .mx-table .cell:hover, .mx-datepicker-main .mx-table .cell:focus, .mx-datepicker-main .mx-table .cell.actived, .mx-datepicker-main .mx-table .cell.active, .mx-datepicker-main .mx-table .cell.in-range {\n  opacity: 1;\n  color: var(--color-primary-element-text);\n  background-color: var(--color-primary-element);\n  font-weight: bold;\n}\n.mx-datepicker-main .mx-table .cell.disabled {\n  opacity: 0.5;\n  color: var(--color-text-lighter);\n  border-radius: 0;\n  background-color: var(--color-background-darker);\n}\n.mx-datepicker-main .mx-table .mx-week-number {\n  text-align: center;\n  opacity: 0.7;\n  border-radius: 50px;\n}\n.mx-datepicker-main .mx-table span.mx-week-number,\n.mx-datepicker-main .mx-table li.mx-week-number,\n.mx-datepicker-main .mx-table span.cell,\n.mx-datepicker-main .mx-table li.cell {\n  min-height: 32px;\n}\n.mx-datepicker-main .mx-table.mx-table-date thead, .mx-datepicker-main .mx-table.mx-table-date tbody, .mx-datepicker-main .mx-table.mx-table-year, .mx-datepicker-main .mx-table.mx-table-month {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n}\n.mx-datepicker-main .mx-table.mx-table-date thead tr, .mx-datepicker-main .mx-table.mx-table-date tbody tr, .mx-datepicker-main .mx-table.mx-table-year tr, .mx-datepicker-main .mx-table.mx-table-month tr {\n  display: inline-flex;\n  align-items: center;\n  flex: 1 1 32px;\n  justify-content: space-around;\n  min-height: 32px;\n}\n.mx-datepicker-main .mx-table.mx-table-date thead th,\n.mx-datepicker-main .mx-table.mx-table-date thead td, .mx-datepicker-main .mx-table.mx-table-date tbody th,\n.mx-datepicker-main .mx-table.mx-table-date tbody td, .mx-datepicker-main .mx-table.mx-table-year th,\n.mx-datepicker-main .mx-table.mx-table-year td, .mx-datepicker-main .mx-table.mx-table-month th,\n.mx-datepicker-main .mx-table.mx-table-month td {\n  display: flex;\n  align-items: center;\n  flex: 0 1 32%;\n  justify-content: center;\n  min-width: 32px;\n  height: 95%;\n  min-height: 32px;\n  transition: background 100ms ease-in-out;\n}\n.mx-datepicker-main .mx-table.mx-table-year tr th,\n.mx-datepicker-main .mx-table.mx-table-year tr td {\n  flex-basis: 48%;\n}\n.mx-datepicker-main .mx-table.mx-table-date tr th,\n.mx-datepicker-main .mx-table.mx-table-date tr td {\n  flex-basis: 32px;\n}\n.mx-datepicker-main .mx-btn {\n  min-width: 32px;\n  height: 32px;\n  margin: 0 2px !important;\n  padding: 7px 10px;\n  cursor: pointer;\n  text-decoration: none;\n  opacity: 0.5;\n  color: var(--color-text-lighter);\n  border-radius: 32px;\n  line-height: 20px;\n}\n.mx-datepicker-main .mx-btn:hover, .mx-datepicker-main .mx-btn:focus {\n  opacity: 1;\n  color: var(--color-main-text);\n  background-color: var(--color-background-darker);\n}\n.mx-datepicker-main .mx-calendar-header, .mx-datepicker-main .mx-time-header {\n  display: inline-flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  height: var(--default-clickable-area);\n  margin-bottom: 4px;\n}\n.mx-datepicker-main .mx-calendar-header button, .mx-datepicker-main .mx-time-header button {\n  min-width: 32px;\n  min-height: 32px;\n  margin: 0;\n  cursor: pointer;\n  text-align: center;\n  text-decoration: none;\n  opacity: 0.7;\n  color: var(--color-main-text);\n  border-radius: 32px;\n  line-height: 20px;\n}\n.mx-datepicker-main .mx-calendar-header button:hover, .mx-datepicker-main .mx-time-header button:hover, .mx-datepicker-main .mx-calendar-header button:focus, .mx-datepicker-main .mx-time-header button:focus {\n  opacity: 1;\n  color: var(--color-main-text);\n  background-color: var(--color-background-darker);\n}\n.mx-datepicker-main .mx-calendar-header button.mx-btn-icon-double-left, .mx-datepicker-main .mx-time-header button.mx-btn-icon-double-left, .mx-datepicker-main .mx-calendar-header button.mx-btn-icon-left, .mx-datepicker-main .mx-time-header button.mx-btn-icon-left, .mx-datepicker-main .mx-calendar-header button.mx-btn-icon-right, .mx-datepicker-main .mx-time-header button.mx-btn-icon-right, .mx-datepicker-main .mx-calendar-header button.mx-btn-icon-double-right, .mx-datepicker-main .mx-time-header button.mx-btn-icon-double-right {\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  padding: 0;\n}\n.mx-datepicker-main .mx-calendar-header button.mx-btn-icon-double-left > i, .mx-datepicker-main .mx-time-header button.mx-btn-icon-double-left > i, .mx-datepicker-main .mx-calendar-header button.mx-btn-icon-left > i, .mx-datepicker-main .mx-time-header button.mx-btn-icon-left > i, .mx-datepicker-main .mx-calendar-header button.mx-btn-icon-right > i, .mx-datepicker-main .mx-time-header button.mx-btn-icon-right > i, .mx-datepicker-main .mx-calendar-header button.mx-btn-icon-double-right > i, .mx-datepicker-main .mx-time-header button.mx-btn-icon-double-right > i {\n  background-repeat: no-repeat;\n  background-size: 16px;\n  background-position: center;\n  filter: var(--background-invert-if-dark);\n  display: inline-block;\n  width: 32px;\n  height: 32px;\n}\n.mx-datepicker-main .mx-calendar-header button.mx-btn-icon-double-left > i::after, .mx-datepicker-main .mx-time-header button.mx-btn-icon-double-left > i::after, .mx-datepicker-main .mx-calendar-header button.mx-btn-icon-double-left > i::before, .mx-datepicker-main .mx-time-header button.mx-btn-icon-double-left > i::before, .mx-datepicker-main .mx-calendar-header button.mx-btn-icon-left > i::after, .mx-datepicker-main .mx-time-header button.mx-btn-icon-left > i::after, .mx-datepicker-main .mx-calendar-header button.mx-btn-icon-left > i::before, .mx-datepicker-main .mx-time-header button.mx-btn-icon-left > i::before, .mx-datepicker-main .mx-calendar-header button.mx-btn-icon-right > i::after, .mx-datepicker-main .mx-time-header button.mx-btn-icon-right > i::after, .mx-datepicker-main .mx-calendar-header button.mx-btn-icon-right > i::before, .mx-datepicker-main .mx-time-header button.mx-btn-icon-right > i::before, .mx-datepicker-main .mx-calendar-header button.mx-btn-icon-double-right > i::after, .mx-datepicker-main .mx-time-header button.mx-btn-icon-double-right > i::after, .mx-datepicker-main .mx-calendar-header button.mx-btn-icon-double-right > i::before, .mx-datepicker-main .mx-time-header button.mx-btn-icon-double-right > i::before {\n  content: none;\n}\n.mx-datepicker-main .mx-calendar-header button.mx-btn-text, .mx-datepicker-main .mx-time-header button.mx-btn-text {\n  line-height: initial;\n}\n.mx-datepicker-main .mx-calendar-header .mx-calendar-header-label, .mx-datepicker-main .mx-time-header .mx-calendar-header-label {\n  display: flex;\n}\n.mx-datepicker-main .mx-calendar-header .mx-btn-icon-double-left > i, .mx-datepicker-main .mx-time-header .mx-btn-icon-double-left > i {\n  background-image: url(\"data:image/svg+xml,%3c!--%20-%20SPDX-FileCopyrightText:%202020%20Google%20Inc.%20-%20SPDX-License-Identifier:%20Apache-2.0%20--%3e%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='24'%20height='24'%20fill='%23222'%3e%3cpath%20d='M18.4%207.4L17%206l-6%206%206%206%201.4-1.4-4.6-4.6%204.6-4.6m-6%200L11%206l-6%206%206%206%201.4-1.4L7.8%2012l4.6-4.6z'/%3e%3c/svg%3e\");\n}\n.mx-datepicker-main .mx-calendar-header .mx-btn-icon-left > i, .mx-datepicker-main .mx-time-header .mx-btn-icon-left > i {\n  background-image: url(\"data:image/svg+xml,%3c!--%20-%20SPDX-FileCopyrightText:%202020%20Google%20Inc.%20-%20SPDX-License-Identifier:%20Apache-2.0%20--%3e%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='24'%20height='24'%20fill='%23222'%3e%3cpath%20d='M15.4%2016.6L10.8%2012l4.6-4.6L14%206l-6%206%206%206%201.4-1.4z'/%3e%3c/svg%3e\");\n}\n.mx-datepicker-main .mx-calendar-header .mx-btn-icon-right > i, .mx-datepicker-main .mx-time-header .mx-btn-icon-right > i {\n  background-image: url(\"data:image/svg+xml,%3c!--%20-%20SPDX-FileCopyrightText:%202020%20Google%20Inc.%20-%20SPDX-License-Identifier:%20Apache-2.0%20--%3e%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='24'%20height='24'%20fill='%23222'%3e%3cpath%20d='M8.6%2016.6l4.6-4.6-4.6-4.6L10%206l6%206-6%206-1.4-1.4z'/%3e%3c/svg%3e\");\n}\n.mx-datepicker-main .mx-calendar-header .mx-btn-icon-double-right > i, .mx-datepicker-main .mx-time-header .mx-btn-icon-double-right > i {\n  background-image: url(\"data:image/svg+xml,%3c!--%20-%20SPDX-FileCopyrightText:%202020%20Google%20Inc.%20-%20SPDX-License-Identifier:%20Apache-2.0%20--%3e%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='24'%20height='24'%20fill='%23222'%3e%3cpath%20d='M5.6%207.4L7%206l6%206-6%206-1.4-1.4%204.6-4.6-4.6-4.6m6%200L13%206l6%206-6%206-1.4-1.4%204.6-4.6-4.6-4.6z'/%3e%3c/svg%3e\");\n}\n.mx-datepicker-main .mx-calendar-header button.mx-btn-icon-right, .mx-datepicker-main .mx-time-header button.mx-btn-icon-right {\n  order: 2;\n}\n.mx-datepicker-main .mx-calendar-header button.mx-btn-icon-double-right, .mx-datepicker-main .mx-time-header button.mx-btn-icon-double-right {\n  order: 3;\n}\n.mx-datepicker-main .mx-calendar-week-mode .mx-date-row .mx-week-number {\n  font-weight: bold;\n}\n.mx-datepicker-main .mx-calendar-week-mode .mx-date-row:hover, .mx-datepicker-main .mx-calendar-week-mode .mx-date-row.mx-active-week {\n  opacity: 1;\n  border-radius: 50px;\n  background-color: var(--color-background-dark);\n}\n.mx-datepicker-main .mx-calendar-week-mode .mx-date-row:hover td, .mx-datepicker-main .mx-calendar-week-mode .mx-date-row.mx-active-week td {\n  background-color: transparent;\n}\n.mx-datepicker-main .mx-calendar-week-mode .mx-date-row:hover td, .mx-datepicker-main .mx-calendar-week-mode .mx-date-row:hover td:hover, .mx-datepicker-main .mx-calendar-week-mode .mx-date-row:hover td:focus, .mx-datepicker-main .mx-calendar-week-mode .mx-date-row.mx-active-week td, .mx-datepicker-main .mx-calendar-week-mode .mx-date-row.mx-active-week td:hover, .mx-datepicker-main .mx-calendar-week-mode .mx-date-row.mx-active-week td:focus {\n  color: inherit;\n}\n.mx-datepicker-main .mx-calendar-week-mode .mx-date-row.mx-active-week {\n  color: var(--color-primary-element-text);\n  background-color: var(--color-primary-element);\n}\n.mx-datepicker-main .mx-calendar-week-mode .mx-date-row.mx-active-week td {\n  opacity: 0.7;\n  font-weight: normal;\n}\n.mx-datepicker-main .mx-time {\n  background-color: var(--color-main-background);\n}\n.mx-datepicker-main .mx-time .mx-time-header {\n  justify-content: center;\n  border-bottom: 1px solid var(--color-border);\n}\n.mx-datepicker-main .mx-time .mx-time-column {\n  border-left: 1px solid var(--color-border);\n}\n.mx-datepicker-main .mx-time .mx-time-option.active, .mx-datepicker-main .mx-time .mx-time-option:hover,\n.mx-datepicker-main .mx-time .mx-time-item.active,\n.mx-datepicker-main .mx-time .mx-time-item:hover {\n  color: var(--color-primary-element-text);\n  background-color: var(--color-primary-element);\n}\n.mx-datepicker-main .mx-time .mx-time-option.disabled,\n.mx-datepicker-main .mx-time .mx-time-item.disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n  color: var(--color-main-text);\n  background-color: var(--color-main-background);\n}/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-4727c294] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.mx-datepicker[data-v-4727c294] .mx-input-wrapper .mx-input {\n  background-clip: border-box;\n}\n.datetime-picker-inline-icon[data-v-4727c294] {\n  opacity: 0.3;\n  border: none;\n  background-color: transparent;\n  border-radius: 0;\n  padding: 0 !important;\n  margin: 0;\n}\n.datetime-picker-inline-icon--highlighted[data-v-4727c294] {\n  opacity: 0.7;\n}\n.datetime-picker-inline-icon[data-v-4727c294]:focus, .datetime-picker-inline-icon[data-v-4727c294]:hover {\n  opacity: 1;\n}/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.v-popper--theme-dropdown.v-popper__popper.timezone-select__popper .v-popper__wrapper {\n  border-radius: var(--border-radius-large);\n}\n.v-popper--theme-dropdown.v-popper__popper.timezone-select__popper .v-popper__wrapper .v-popper__inner {\n  padding: 4px;\n  border-radius: var(--border-radius-large);\n}\n.v-popper--theme-dropdown.v-popper__popper.timezone-select__popper .v-popper__wrapper .v-popper__inner .timezone-popover-wrapper__label {\n  padding: 4px 0;\n  padding-left: 14px;\n}\n.v-popper--theme-dropdown.v-popper__popper.timezone-select__popper .v-popper__wrapper .v-popper__inner .timezone-popover-wrapper__timezone-select.v-select .vs__dropdown-toggle {\n  border-radius: calc(var(--border-radius-large) - 4px);\n}\n.v-popper--theme-dropdown.v-popper__popper.timezone-select__popper .v-popper__wrapper .v-popper__inner .timezone-popover-wrapper__timezone-select.v-select.vs--open .vs__dropdown-toggle {\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.v-popper--theme-dropdown.v-popper__popper.timezone-select__popper .v-popper__wrapper .v-popper__inner .timezone-popover-wrapper__timezone-select.v-select.vs--open.select--drop-up .vs__dropdown-toggle {\n  border-radius: 0 0 calc(var(--border-radius-large) - 4px) calc(var(--border-radius-large) - 4px);\n}\n.vs__dropdown-menu--floating {\n  z-index: 100001 !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
